// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove browser defaults */
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.App {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* Tab Container cssfile under encryptform */
.APITabs {
  width: 1000px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: #053742;
  margin: 15px auto 7px;
  padding: 10px 5px;
  height: auto;
  overflow: visible;
  color: #E8F0F2;
  box-sizing: border-box;
  border-radius: 10px;
  @media (max-width: 769px) {
    padding: 10px 0;
  }

}

/* Tab Navigation */
ul.nav1,
ul.nav {
  width: 60%;
  margin: 0 auto 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #39A2DB;
  border-radius: 10px;
  @media (max-width: 768px) {
    width: 90%;
  }
}
ul.nav1 li,
ul.nav li {
    width: 50%;
  padding: 5px;
  list-style: none;
  text-align: center;
  cursor: pointer;
  transition: all 0.7s;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}
/*ul.nav li:nth-child(2) {*/
  ul.nav1 li:first-child,
  ul.nav li:first-child {
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
}
ul.nav1 li:last-child,
ul.nav li:last-child {
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}
ul.nav1 li:hover,
ul.nav li:hover {
  background: rgba(50, 224, 196, 0.15);
}
ul.nav li.gametab {
  background: #214225;
}
ul.nav1 li.hidden,
ul.nav li.hidden {
  display: none;
}
ul.nav1 li.active,
ul.nav li.active {
  background: #39A2DB;
}

/* First and Second Tab Styles */
.GetAsset p,
.AddAsset p,
.ConsumeAsset p {
  font-size: 5px;
  text-align: center;
}

div.copy {
  float: right;
  top: 0px;
  right: 0px;
  background: grey;
  color:blue;
  border-radius: 5px;
  padding: 5px;
}

div.form.active {
  background-color: #1d3f4e;
}

div.form,
div.encrypted,
div.raw {
  padding: 10px;
  margin: 5px;
  font-size: 10pt;
  border: 1px solid grey;
  border-radius: 10px;
  float:left;
  width: 300px;
  overflow:scroll;
}

div.raw {
  word-wrap: break-work;
  font-style: italic;
}

textarea.rawinput, 
textarea.encrypted {
  width:280px;
  resize: none;
  height: 150px;
  background: rgb(206, 206, 206);
}





/*******************/
/* SMARTFORM below */
/*******************/


.smartform {
  width:100%;
  display: flex;
  flex-direction: column;
  border: 3px solid #f0f0f0;
  margin-bottom: 1rem;
  border-radius: 5px;
  background: #f0f0f0;
}

.smartform .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background: #f0f0f0;
  color: #000000;
  padding: 0.5rem;
  font-weight: bold;
}
.smartform .headerLeft {
  flex: 1 1;
  text-align: left;
}

.smartform .headerRight {
  flex: 1 1;
  text-align: right;
}

.smartform .input-row {
  display: flex;
  row-gap: 1rem;
  background: #f0f0f0;
}

.smartform .input-row .form-left {
  flex: 0 0 40%;
  display: flex;
  flex-direction: column;
  background: #cccccc;
  color: #000000
}

.smartform .input-row .form-left > div {
  display: flex;
  align-items: center;
}

.smartform .input-row .form-left label {
  width: 120px; 
  text-align: right;
  padding-right: 5px;
}

.smartform .input-row .form-right {
  flex: 0 0 60%;
  display: flex;
  flex-direction: column;
  background: #cccccc;
  color: #000000;
  padding-bottom:10px;
}

.smartform label.intro {
  font-size: 8pt;
  font-style: italic;
}

.smartform .form-submit {
  display: flex;
  margin-top: 0.5rem;
  background: #f0f0f0;
}

.smartform .form-submit button {
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  background: #39A2DB;
  border-radius: 5px;
}

.smartform .result {
  display: flex;
  flex-direction: column;
  background: #f0f0f0;
  color: #000000;
}

.smartform .result .feedback {
  min-height: 1rem;
  padding: 5px;
}

/* Styles for the deprecation notice section */
.depreciation-section {
  margin-top: 0.5rem;
}

.depreciation-section h4 {
  margin-bottom: 0.25rem;
  font-size: 0.75rem;
  color: #ff5959; /* optional: highlight the warning */
}

/* Table styling */
.depreciation-section table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem;
  color: #000000;
}

/* Table cells */
.depreciation-section td {
  border: None;
  padding: 6px 10px;
  vertical-align: top;
  white-space: pre-line;
}

/* Optional: make the date column narrower */
.depreciation-section td:first-child {
  width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Play2earn/Encryptform/index.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB;IACE,eAAe;EACjB;;AAEF;;AAEA,mBAAmB;AACnB;;EAEE,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB;IACE,UAAU;EACZ;AACF;AACA;;IAEI,UAAU;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;AAC/B;AACA,2BAA2B;EACzB;;IAEE,gCAAgC;IAChC,6BAA6B;AACjC;AACA;;EAEE,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;;;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;;;;;AAMA,oBAAoB;AACpB,oBAAoB;AACpB,oBAAoB;;;AAGpB;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAE,oCAAoC;AACtD;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,YAAY;AACd","sourcesContent":["/* Remove browser defaults */\n* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n.App {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n/* Tab Container cssfile under encryptform */\n.APITabs {\n  width: 1000px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  background: #053742;\n  margin: 15px auto 7px;\n  padding: 10px 5px;\n  height: auto;\n  overflow: visible;\n  color: #E8F0F2;\n  box-sizing: border-box;\n  border-radius: 10px;\n  @media (max-width: 769px) {\n    padding: 10px 0;\n  }\n\n}\n\n/* Tab Navigation */\nul.nav1,\nul.nav {\n  width: 60%;\n  margin: 0 auto 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #39A2DB;\n  border-radius: 10px;\n  @media (max-width: 768px) {\n    width: 90%;\n  }\n}\nul.nav1 li,\nul.nav li {\n    width: 50%;\n  padding: 5px;\n  list-style: none;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.7s;\n  border-bottom-left-radius: 10px;\n  border-top-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border-top-right-radius: 10px;\n}\n/*ul.nav li:nth-child(2) {*/\n  ul.nav1 li:first-child,\n  ul.nav li:first-child {\n    border-bottom-right-radius: 10px;\n    border-top-right-radius: 10px;\n}\nul.nav1 li:last-child,\nul.nav li:last-child {\n  border-bottom-right-radius: 10px;\n  border-top-right-radius: 10px;\n}\nul.nav1 li:hover,\nul.nav li:hover {\n  background: rgba(50, 224, 196, 0.15);\n}\nul.nav li.gametab {\n  background: #214225;\n}\nul.nav1 li.hidden,\nul.nav li.hidden {\n  display: none;\n}\nul.nav1 li.active,\nul.nav li.active {\n  background: #39A2DB;\n}\n\n/* First and Second Tab Styles */\n.GetAsset p,\n.AddAsset p,\n.ConsumeAsset p {\n  font-size: 5px;\n  text-align: center;\n}\n\ndiv.copy {\n  float: right;\n  top: 0px;\n  right: 0px;\n  background: grey;\n  color:blue;\n  border-radius: 5px;\n  padding: 5px;\n}\n\ndiv.form.active {\n  background-color: #1d3f4e;\n}\n\ndiv.form,\ndiv.encrypted,\ndiv.raw {\n  padding: 10px;\n  margin: 5px;\n  font-size: 10pt;\n  border: 1px solid grey;\n  border-radius: 10px;\n  float:left;\n  width: 300px;\n  overflow:scroll;\n}\n\ndiv.raw {\n  word-wrap: break-work;\n  font-style: italic;\n}\n\ntextarea.rawinput, \ntextarea.encrypted {\n  width:280px;\n  resize: none;\n  height: 150px;\n  background: rgb(206, 206, 206);\n}\n\n\n\n\n\n/*******************/\n/* SMARTFORM below */\n/*******************/\n\n\n.smartform {\n  width:100%;\n  display: flex;\n  flex-direction: column;\n  border: 3px solid #f0f0f0;\n  margin-bottom: 1rem;\n  border-radius: 5px;\n  background: #f0f0f0;\n}\n\n.smartform .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  background: #f0f0f0;\n  color: #000000;\n  padding: 0.5rem;\n  font-weight: bold;\n}\n.smartform .headerLeft {\n  flex: 1;\n  text-align: left;\n}\n\n.smartform .headerRight {\n  flex: 1;\n  text-align: right;\n}\n\n.smartform .input-row {\n  display: flex;\n  row-gap: 1rem;\n  background: #f0f0f0;\n}\n\n.smartform .input-row .form-left {\n  flex: 0 0 40%;\n  display: flex;\n  flex-direction: column;\n  background: #cccccc;\n  color: #000000\n}\n\n.smartform .input-row .form-left > div {\n  display: flex;\n  align-items: center;\n}\n\n.smartform .input-row .form-left label {\n  width: 120px; \n  text-align: right;\n  padding-right: 5px;\n}\n\n.smartform .input-row .form-right {\n  flex: 0 0 60%;\n  display: flex;\n  flex-direction: column;\n  background: #cccccc;\n  color: #000000;\n  padding-bottom:10px;\n}\n\n.smartform label.intro {\n  font-size: 8pt;\n  font-style: italic;\n}\n\n.smartform .form-submit {\n  display: flex;\n  margin-top: 0.5rem;\n  background: #f0f0f0;\n}\n\n.smartform .form-submit button {\n  width: 100%;\n  padding: 0.75rem;\n  font-size: 1rem;\n  background: #39A2DB;\n  border-radius: 5px;\n}\n\n.smartform .result {\n  display: flex;\n  flex-direction: column;\n  background: #f0f0f0;\n  color: #000000;\n}\n\n.smartform .result .feedback {\n  min-height: 1rem;\n  padding: 5px;\n}\n\n/* Styles for the deprecation notice section */\n.depreciation-section {\n  margin-top: 0.5rem;\n}\n\n.depreciation-section h4 {\n  margin-bottom: 0.25rem;\n  font-size: 0.75rem;\n  color: #ff5959; /* optional: highlight the warning */\n}\n\n/* Table styling */\n.depreciation-section table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.75rem;\n  color: #000000;\n}\n\n/* Table cells */\n.depreciation-section td {\n  border: None;\n  padding: 6px 10px;\n  vertical-align: top;\n  white-space: pre-line;\n}\n\n/* Optional: make the date column narrower */\n.depreciation-section td:first-child {\n  width: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
